import React, { useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';
import './HomePlan.css';
import api from '../services/api';


const API_URL = api.defaults.baseURL + '/manager/home-plans';

// --- Icon Components ---
const AddIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/></svg>;
const EditIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/><path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/></svg>;
const DeleteIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/></svg>;
const UploadIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16"><path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/><path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/></svg>;
const SearchIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/></svg>;


// --- Helper Components ---
const SkeletonRow = ({ columns }) => (
  <tr className="skeleton-row">
    {Array.from({ length: columns }).map((_, index) => (
      <td key={index}><div className="skeleton-line"></div></td>
    ))}
  </tr>
);
// --- **UPDATED** CustomFileInput Component ---
const CustomFileInput = ({ onChange, required, existingImageUrl }) => {
    const [fileName, setFileName] = useState('');
    const [isDragActive, setIsDragActive] = useState(false);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFileName(file.name);
            onChange(e);
        }
    };

    const handleDrag = (e, active) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragActive(active);
    };

    const handleDrop = (e) => {
        handleDrag(e, false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const mockEvent = { target: { name: 'image', files: e.dataTransfer.files } };
            setFileName(e.dataTransfer.files[0].name);
            onChange(mockEvent);
        }
    };

    // Determine what to display inside the drop zone
    const renderContent = () => {
        // If a new file has been selected, show its name
        if (fileName) {
            return (
                <>
                    <span className="file-name">{fileName}</span>
                    <span className="file-prompt">Click or drag to replace</span>
                </>
            );
        }
        // If editing and an existing image URL is provided, show it
        if (existingImageUrl) {
            return (
                <>
                    <img src={existingImageUrl} alt="Current Plan" className="file-preview-image" />
                    <span className="file-prompt">Drag or click to replace image</span>
                </>
            );
        }
        // Default prompt for adding a new plan
        return (
            <>
                <UploadIcon />
                <span className="file-prompt">Drag & drop an image here, or click to select</span>
            </>
        );
    };

    return (
        <div className="custom-file-input">
            <label 
                htmlFor="image" 
                className={`file-drop-zone ${isDragActive ? 'is-active' : ''}`} 
                onDragEnter={(e) => handleDrag(e, true)} 
                onDragLeave={(e) => handleDrag(e, false)} 
                onDragOver={(e) => handleDrag(e, true)} 
                onDrop={handleDrop}
            >
                <input 
                    type="file" 
                    id="image" 
                    name="image" 
                    accept="image/*" 
                    onChange={handleFileChange} 
                    required={required} 
                    className="visually-hidden" 
                />
                <div className="drop-zone-content">
                    {renderContent()}
                </div>
            </label>
        </div>
    );
};

// --- **UPDATED** Modal Component ---
const HomePlanFormModal = ({ isOpen, onClose, onSubmit, initialData, mode = 'add', isSubmitting }) => {
  const [form, setForm] = useState({});
  
  useEffect(() => {
    if (isOpen) {
      const defaultData = { 
          homePlanName: '', elevation: '', lot: '', lotPrice: '', homePrice: '', 
          unfinishedBasement: '', finishedBasement: '', image: null 
      };
      setForm({ ...defaultData, ...(initialData || {}) });
    }
  }, [isOpen, initialData]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setForm(prev => ({ ...prev, [name]: files ? files[0] : value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{mode === 'add' ? 'Add New Home Plan' : 'Edit Home Plan'}</h2>
          <button onClick={onClose} className="btn-close" aria-label="Close"></button>
        </div>
        <div className="modal-body">
            <form onSubmit={handleSubmit} id="homePlanForm">
                <div className="row g-2 mb-3">
                    {/* ... (input fields are unchanged) ... */}
                    <div className="col-md-4"><input type="text" name="homePlanName" className="form-control form-control-sm" placeholder="Home Plan Name" value={form.homePlanName || ''} onChange={handleChange} required /></div>
                    <div className="col-md-4"><input type="text" name="elevation" className="form-control form-control-sm" placeholder="Elevation" value={form.elevation || ''} onChange={handleChange} required /></div>
                    <div className="col-md-4"><input type="text" name="lot" className="form-control form-control-sm" placeholder="Lot Number" value={form.lot || ''} onChange={handleChange} required /></div>
                    <div className="col-md-4"><input type="number" name="homePrice" className="form-control form-control-sm" placeholder="Base Home Price" value={form.homePrice || ''} onChange={handleChange} required /></div>
                    <div className="col-md-4"><input type="number" name="lotPrice" className="form-control form-control-sm" placeholder="Lot Premium Price" value={form.lotPrice || ''} onChange={handleChange} required /></div>
                    <div className="col-md-4"></div> {/* Spacer */}
                    <div className="col-md-4"><input type="number" name="unfinishedBasement" className="form-control form-control-sm" placeholder="Unfinished Basement Price" value={form.unfinishedBasement || ''} onChange={handleChange} /></div>
                    <div className="col-md-4"><input type="number" name="finishedBasement" className="form-control form-control-sm" placeholder="Finished Basement Price" value={form.finishedBasement || ''} onChange={handleChange} /></div>
                    
                    <div className="col-12">
                        <CustomFileInput 
                            onChange={handleChange} 
                            // The image is only strictly required when adding a new plan
                            required={mode === 'add'} 
                            // Pass the existing image URL to the component for preview
                            existingImageUrl={initialData?.imageUrl}
                        />
                    </div>
                </div>
            </form>
        </div>
        <div className="modal-footer">
            <button type="button" className="btn btn-sm btn-secondary" onClick={onClose} disabled={isSubmitting}>Cancel</button>
            <button type="submit" form="homePlanForm" className="btn btn-sm btn-primary" disabled={isSubmitting}>
                {isSubmitting && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                {isSubmitting ? 'Saving...' : (mode === 'add' ? 'Create Plan' : 'Save Changes')}
            </button>
        </div>
      </div>
    </div>
  );
};



// --- Table Components ---
const HomePlanTableRow = ({ plan, onEdit, onDelete }) => (
  <tr>
    <td><div className="plan-name-cell">{plan.imageUrl && <img src={plan.imageUrl} alt={plan.homePlanName} className="table-image" />}<span>{plan.homePlanName}</span></div></td>
    <td>{plan.elevation}</td>
    <td>{plan.lot}</td>
    <td>${Number(plan.homePrice).toLocaleString()}</td>
    <td>${Number(plan.lotPrice).toLocaleString()}</td>
    <td>${Number(plan.unfinishedBasement || 0).toLocaleString()}</td>
    <td>${Number(plan.finishedBasement || 0).toLocaleString()}</td>
    <td><div className="action-btn-group"><button onClick={() => onEdit(plan)} className="btn-icon btn-edit" aria-label="Edit"><EditIcon /></button><button onClick={() => onDelete(plan._id)} className="btn-icon btn-delete" aria-label="Delete"><DeleteIcon /></button></div></td>
  </tr>
);

const HomePlanTable = ({ plans, onEdit, onDelete, isLoading }) => {
    const tableHeaders = ["Plan Name", "Elevation", "Lot", "Home Price", "Lot Price", "Unfinished Bsmt", "Finished Bsmt", "Actions"];
    return (
      <div className="table-wrapper">
        <table className="home-plan-table table-hover">
          <thead><tr>{tableHeaders.map(h => <th key={h}>{h}</th>)}</tr></thead>
          <tbody>
            {isLoading ? (Array.from({ length: 6 }).map((_, i) => <SkeletonRow key={i} columns={tableHeaders.length} />))
             : plans.length > 0 ? (plans.map(plan => (<HomePlanTableRow key={plan._id} plan={plan} onEdit={onEdit} onDelete={onDelete}/>)))
             : (<tr><td colSpan={tableHeaders.length} className="no-data-cell">No home plans found for your search.</td></tr>)}
          </tbody>
        </table>
      </div>
    );
};

// --- Main Page Component (FIXED) ---
function HomePlan() {
    const [plans, setPlans] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState('add');
    const [currentPlan, setCurrentPlan] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [searchTerm, setSearchTerm] = useState(''); // NEW state for the search term

    const fetchHomePlans = useCallback(async () => {
      setIsLoading(true);
      setError('');
      try {
        const token = localStorage.getItem('authToken');
        if (!token) throw new Error("Authentication token not found.");
        const { data } = await axios.get(API_URL, { headers: { 'Authorization': `Bearer ${token}` } });
        setPlans(data);
      } catch (err) {
        setError(err.response?.data?.message || err.message || 'Failed to fetch home plans.');
      } finally {
        setIsLoading(false);
      }
    }, []);

    useEffect(() => { fetchHomePlans(); }, [fetchHomePlans]);
    
    // NEW: Memoized hook for filtering and sorting plans
    const filteredAndSortedPlans = useMemo(() => {
        const lowercasedTerm = searchTerm.toLowerCase();
        
        // Filter first
        const filtered = plans.filter(plan => 
            plan.homePlanName.toLowerCase().includes(lowercasedTerm) ||
            plan.lot.toLowerCase().includes(lowercasedTerm)
        );

        // Then sort
        return filtered.sort((a, b) => a.lot.localeCompare(b.lot, undefined, { numeric: true }));
    }, [plans, searchTerm]);

    const handleOpenAddModal = () => { setModalMode('add'); setCurrentPlan(null); setIsModalOpen(true); };
    const handleOpenEditModal = (plan) => { setModalMode('edit'); setCurrentPlan(plan); setIsModalOpen(true); };
    const handleCloseModal = () => { setIsModalOpen(false); setCurrentPlan(null); };

    const handleSubmit = async (formData) => {
        const token = localStorage.getItem('authToken');
        if (!token) {
            setError("Action failed: No authentication token found.");
            return;
        }
        
        setError('');
        setIsSubmitting(true);

        try {
            const dataPayload = new FormData();
            dataPayload.append('homePlanName', formData.homePlanName);
            dataPayload.append('elevation', formData.elevation);
            dataPayload.append('lot', formData.lot);
            dataPayload.append('lotPrice', formData.lotPrice);
            dataPayload.append('homePrice', formData.homePrice);
            dataPayload.append('unfinishedBasement', formData.unfinishedBasement || 0);
            dataPayload.append('finishedBasement', formData.finishedBasement || 0);
            if (formData.image instanceof File) {
                dataPayload.append('imageFile', formData.image);
            }
            const config = { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } };
            if (modalMode === 'add') {
                await axios.post(API_URL, dataPayload, config);
            } else if (modalMode === 'edit' && currentPlan) {
                await axios.put(`${API_URL}/by-id/${currentPlan._id}`, dataPayload, config);
            }
            handleCloseModal();
            await fetchHomePlans();
        } catch (err) {
            const errorMessage = err.response?.data?.message || `Failed to ${modalMode === 'add' ? 'create' : 'update'} plan.`;
            setError(errorMessage);
        } finally {
            setIsSubmitting(false);
        }
    };
    
    const handleDelete = async (planId) => {
      if (!window.confirm("Are you sure you want to permanently delete this plan?")) return;
      const token = localStorage.getItem('authToken');
      if (!token) { setError("Action failed: No token found."); return; }
      setError('');
      const originalPlans = [...plans];
      setPlans(prev => prev.filter(p => p._id !== planId));
      try {
        await axios.delete(`${API_URL}/by-id/${planId}`, { headers: { 'Authorization': `Bearer ${token}` } });
      } catch (err) {
        setError('Delete failed. Reverting changes.');
        setPlans(originalPlans);
      }
    };

    return (
      <div className="home-plan-page-container">
        {error && <div className="error-toast" onClick={() => setError('')}>{error}</div>}
        <header className="page-header">
            <h1>Manage Home Plans</h1>
            <div className="header-actions">
                {/* NEW: Search Bar */}
                <div className="search-bar">
                    <SearchIcon />
                    <input 
                        type="text" 
                        placeholder="Search by Plan Name or Lot..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <button className="btn btn-primary" onClick={handleOpenAddModal}><AddIcon /> Add New Plan</button>
            </div>
        </header>
        <main className="content-card">
          <HomePlanTable 
            plans={filteredAndSortedPlans} // Use the filtered and sorted list
            onEdit={handleOpenEditModal} 
            onDelete={handleDelete} 
            isLoading={isLoading}
          />
        </main>
        <HomePlanFormModal 
            isOpen={isModalOpen} 
            onClose={handleCloseModal} 
            onSubmit={handleSubmit} 
            initialData={currentPlan} 
            mode={modalMode}
            isSubmitting={isSubmitting} 
        />
      </div>
    );
}

export default HomePlan;